import { h, render } from 'preact';
import Button from './Button';
import route from '../route';

export default ({ children, ...props}) => {

    const { files = [] } = props;

    return (
        <section class="downloads-page__group">
            <h2 class="downloads-page__group__title">
                Поддержка для <span>{ props.short_title }</span>
            </h2>

            <section class="downloads-page__product">
                <div class="downloads-page__product__image-wrapper">
                    <img
                        src={ props.picture }
                        class="downloads-page__product__image"
                        alt="" />
                </div>
                <div class="downloads-page__product__navigation">
                    {/*
                    <Button url={route('downloads')} style="common" className="downloads-page__product__navigation__button">
                        Другое устройство
                    </Button>
                    */}
                    {
                        props.product_url
                            ?
                                <Button
                                    url={props.product_url}
                                    style="common"
                                    className="downloads-page__product__navigation__button">
                                    Страница устройства
                                </Button>
                            : null
                    }
                </div>
            </section>

            {
                files.length
                    ?
                        <ul class="downloads-page__links">
                            {
                                files.map(file => (
                                    <li class="downloads-page__links__item">
                                        <div class="downloads-page__links__wrapper">
                                            <span class="downloads-page__links__title">
                                                { file.title }
                                            </span>
                                            {
                                                file.date
                                                    ?
                                                        <span class="downloads-page__links__info">
                                                            <span class="downloads-page__links__info__label">Дата&nbsp;</span>
                                                            <span class="downloads-page__links__info__value">
                                                                { file.date }
                                                            </span>
                                                        </span>
                                                    : null
                                            }
                                            {
                                                file.version
                                                    ?
                                                        <span class="downloads-page__links__info">
                                                            <span class="downloads-page__links__info__label">
                                                                Версия&nbsp;
                                                            </span>
                                                            <span class="downloads-page__links__info__value">
                                                                { file.version }
                                                            </span>
                                                        </span>
                                                    : null
                                            }
                                        </div>
                                        
                                        <a href={ file.url } class="downloads-page__links__link" download>
                                            { file.extension ? '.' + file.extension : '' } { file.size || '' }
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                    :
                        <div class="informer _error" style="">
                            К сожалению в нашей базе нет файлов для данного устройства
                        </div>
            }
        </section>
    )
}